export const parkinglots = [
	{
		id: 1,
		number: '1',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: 'for disabled people',
			bg: 'за хора с увреждания',
			ru: 'для людей с ограниченными возможностями'
		},
		netArea: 26.36,
		grossArea: 48.83,
		price: 10000,
		taxPrice: 9800,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 2,
		number: '2',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: 'for disabled people',
			bg: 'за хора с увреждания',
			ru: 'для людей с ограниченными возможностями'
		},
		netArea: 26.36,
		grossArea: 48.83,
		price: 10000,
		taxPrice: 13000,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 3,
		number: '3',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 26.36,
		grossArea: 48.83,
		price: 10000,
		taxPrice: 18000,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 4,
		number: '4',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: 'for disabled people',
			bg: 'за хора с увреждания',
			ru: 'для людей с ограниченными возможностями'
		},
		netArea: 26.36,
		grossArea: 48.83,
		price: 10000,
		taxPrice: 14000,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 5,
		number: '5',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 15300,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 6,
		number: '6',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system + Cellar 3 A-B',
			bg: 'паркосистема на 2 нива + Изба 3 А-Б',
			ru: '2-х уровневая система парковки + Подвал 3 А-Б'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 18800,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 7,
		number: '7',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 9800,
    status: {
      en: 'reserved',
      bg: 'резервирано',
      ru: 'зарезервированный'
    }
	},{
		id: 8,
		number: '8',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system + Cellar 2 A-B',
			bg: 'паркосистема на 2 нива + Изба 2 А-Б',
			ru: '2-х уровневая система парковки + Подвал 2 А-Б'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 12800,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 9,
		number: '9',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 0,
		status: {
			en: 'sold',
			bg: 'продадено',
			ru: 'проданный'
		}
	},{
		id: 10,
		number: '10',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '+ Cellar 1 A-B',
			bg: '+ Изба 1 А-Б',
			ru: '+ Подвал 1 А-Б'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 0,
		status: {
			en: 'sold',
			bg: 'продадено',
			ru: 'проданный'
		}
	},{
		id: 11,
		number: '11',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '+ Cellar 4 A-B',
			bg: '+ Изба 4 А-Б',
			ru: '+ Подвал 4 А-Б'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 13500,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 12,
		number: '12',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 9800,
    status: {
      en: 'reserved',
      bg: 'резервирано',
      ru: 'зарезервированный'
    }
	},{
		id: 13,
		number: '13',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 9800,
    status: {
      en: 'reserved',
      bg: 'резервирано',
      ru: 'зарезервированный'
    }
	},{
		id: 14,
		number: '14',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 9800,
    status: {
      en: 'reserved',
      bg: 'резервирано',
      ru: 'зарезервированный'
    }
	},{
		id: 15,
		number: '15',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 9800,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 16,
		number: '16',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 9800,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 17,
		number: '17',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 9800,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 18,
		number: '18',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '+ Cellar 9 A-B',
			bg: '+ Изба 9 А-Б',
			ru: '+ Подвал 9 А-Б'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 11800,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 19,
		number: '19',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '+ Cellar 8 A-B',
			bg: '+ Изба 8 А-Б',
			ru: '+ Подвал 8 А-Б'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 11600,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 20,
		number: '20',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '+ Cellar 7 A-B',
			bg: '+ Изба 7 А-Б',
			ru: '+ Подвал 7 А-Б'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 11600,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 21,
		number: '21',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 9800,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 22,
		number: '22',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '+ Cellar 5 A-B',
			bg: '+ Изба 5 А-Б',
			ru: '+ Подвал 5 А-Б'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 14700,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 23,
		number: '23',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '+ Cellar 6 A-B',
			bg: '+ Изба 6 А-Б',
			ru: '+ Подвал 6 А-Б'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 15700,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 24,
		number: '24',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 9800,
    status: {
      en: 'reserved',
      bg: 'резервирано',
      ru: 'зарезервированный'
    }
	},{
		id: 25,
		number: '25',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 9800,
    status: {
      en: 'reserved',
      bg: 'резервирано',
      ru: 'зарезервированный'
    }
	},{
		id: 26,
		number: '26',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 15300,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 27,
		number: '27',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 15300,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 28,
		number: '28-29',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 13000,
		taxPrice: 17000,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 30,
		number: '30-31',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 13000,
		taxPrice: 17600,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 32,
		number: '32',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
    netArea: 26.36,
    grossArea: 48.83,
    price: 10000,
    taxPrice: 18000,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 33,
		number: '33',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 15300,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 34,
		number: '34',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 15300,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 35,
		number: '35-36',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 13000,
		taxPrice: 17000,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 37,
		number: '37-38',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 13000,
		taxPrice: 17000,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 39,
		number: '39-40',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 13000,
		taxPrice: 18000,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 41,
		number: '41',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 0,
		status: {
      en: 'sold',
      bg: 'продадено',
      ru: 'проданный'
		}
	},{
		id: 42,
		number: '42',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 0,
		status: {
      en: 'sold',
      bg: 'продадено',
      ru: 'проданный'
		}
	},{
		id: 43,
		number: '43',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '1 level',
			bg: '1 ниво',
			ru: '1 уровень'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 13000,
		taxPrice: 12300,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 45,
		number: '45',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '1 level',
			bg: '1 ниво',
			ru: '1 уровень'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 13000,
		taxPrice: 12300,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 47,
		number: '47',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: 'for disabled people',
			bg: 'за хора с увреждания',
			ru: 'для людей с ограниченными возможностями'
		},
		netArea: 26.36,
		grossArea: 48.83,
		price: 10000,
		taxPrice: 14000,
    status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 48,
		number: '48',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 26.36,
		grossArea: 48.83,
		price: 10000,
		taxPrice: 18000,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 49,
		number: '49',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 13000,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 50,
		number: '50',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 13000,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 51,
		number: '51-52',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 13000,
		taxPrice: 0,
    status: {
      en: 'reserved',
      bg: 'резервирано',
      ru: 'зарезервированный'
    }
	},{
		id: 53,
		number: '53-54',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 13000,
		taxPrice: 0,
		status: {
      en: 'reserved',
      bg: 'резервирано',
      ru: 'зарезервированный'
		}
	},{
		id: 55,
		number: '55',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 9800,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 56,
		number: '56-57',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system + Cellar 10 A-B',
			bg: 'паркосистема на 2 нива + Изба 10 А-Б',
			ru: '2-х уровневая система парковки + Подвал 10 А-Б'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 13000,
		taxPrice: 0,
    status: {
      en: 'reserved',
      bg: 'резервирано',
      ru: 'зарезервированный'
    }
	},{
		id: 58,
		number: '58-59',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 13000,
		taxPrice: 0,
    status: {
      en: 'reserved',
      bg: 'резервирано',
      ru: 'зарезервированный'
    }
	},{
		id: 60,
		number: '60-61',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 13000,
		taxPrice: 0,
    status: {
      en: 'reserved',
      bg: 'резервирано',
      ru: 'зарезервированный'
    }
	},{
		id: 62,
		number: '62',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},		
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 15300,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 63,
		number: '63',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 15000,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 64,
		number: '64',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		description: {
			en: '2-level parking system',
			bg: 'паркосистема на 2 нива',
			ru: '2-х уровневая система парковки'
		},
		netArea: 26.36,
		grossArea: 48.83,
		price: 10000,
		taxPrice: 18000,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 65,
		number: '65',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 9800,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 66,
		number: '66',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 9800,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 67,
		number: '67',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 9800,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 68,
		number: '68',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 12300,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 69,
		number: '69',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 12300,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 70,
		number: '70',
		type: {
			en: 'parking',
			bg: 'паркомясто',
			ru: 'парковка'
		},
		netArea: 18.31,
		grossArea: 33.91,
		price: 8000,
		taxPrice: 12300,
		status: {
			en: 'available',
			bg: 'свободно',
			ru: 'свободный'
		}
	},{
		id: 71,
		number: '1 A-B',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		description: {
			en: '+ Parking 10',
			bg: '+ Паркомясто 10',
			ru: '+ Парковка 10'
		},
		netArea: 6.82,
		grossArea: 6.82,
		price: 2618.88,
		taxPrice: 0,
		status: {
      en: 'sold',
      bg: 'продадено',
      ru: 'проданный'
		}
	},{
		id: 72,
		number: '2 A-B',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		description: {
			en: '+ Parking 8',
			bg: '+ Паркомясто 8',
			ru: '+ Парковка 8'
		},
		netArea: 5.47,
		grossArea: 5.47,
		price: 2100.48,
		taxPrice: 0,
		status: {
			en: 'available',
			bg: 'свободна',
			ru: 'свободный'
		}
	},{
		id: 73,
		number: '3 A-B',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		description: {
			en: '+ Parking 6',
			bg: '+ Паркомясто 6',
			ru: '+ Парковка 6'
		},
		netArea: 7.97,
		grossArea: 7.97,
		price: 3060.48,
		taxPrice: 0,
		status: {
			en: 'available',
			bg: 'свободна',
			ru: 'свободный'
		}
	},{
		id: 74,
		number: '4 A-B',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		description: {
			en: '+ Parking 11',
			bg: '+ Паркомясто 11',
			ru: '+ Парковка 11'
		},
		netArea: 8.41,
		grossArea: 8.41,
		price: 3229.44,
		taxPrice: 0,
		status: {
			en: 'available',
			bg: 'свободна',
			ru: 'свободный'
		}
	},{
		id: 75,
		number: '5 A-B',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		description: {
			en: '+ Parking 22',
			bg: '+ Паркомясто 22',
			ru: '+ Парковка 22'
		},
		netArea: 11.06,
		grossArea: 11.06,
		price: 4247.04,
		taxPrice: 0,
		status: {
			en: 'available',
			bg: 'свободна',
			ru: 'свободный'
		}
	},{
		id: 76,
		number: '6 A-B',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		description: {
			en: '+ Parking 23',
			bg: '+ Паркомясто 23',
			ru: '+ Парковка 23'
		},
		netArea: 13.13,
		grossArea: 13.13,
		price: 5041.936,
		taxPrice: 0,
		status: {
			en: 'available',
			bg: 'свободна',
			ru: 'свободный'
		}
	},{
		id: 77,
		number: '7 A-B',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		description: {
			en: '+ Parking 20',
			bg: '+ Паркомясто 20',
			ru: '+ Парковка 20'
		},
		netArea: 4.1,
		grossArea: 4.1,
		price: 1574.4,
		taxPrice: 0,
		status: {
			en: 'available',
			bg: 'свободна',
			ru: 'свободный'
		}
	},{
		id: 78,
		number: '8 A-B',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		description: {
			en: '+ Parking 19',
			bg: '+ Паркомясто 19',
			ru: '+ Парковка 19'
		},
		netArea: 4.1,
		grossArea: 4.1,
		price: 1574.4,
		taxPrice: 0,
    status: {
			en: 'available',
			bg: 'свободна',
			ru: 'свободный'
		}
	},{
		id: 79,
		number: '9 A-B',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		description: {
			en: '+ Parking 18',
			bg: '+ Паркомясто 18',
			ru: '+ Парковка 18'
		},
		netArea: 4.44,
		grossArea: 4.44,
		price: 1704.96,
		taxPrice: 0,
    status: {
			en: 'available',
			bg: 'свободна',
			ru: 'свободный'
		}
	},{
		id: 80,
		number: '10 A-B',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		description: {
			en: '+ Parking 56-57',
			bg: '+ Паркомясто 56-57',
			ru: '+ Парковка 56-57'
		},
		netArea: 4.7,
		grossArea: 4.7,
		price: 1804.8,
		taxPrice: 0,
    status: {
      en: 'reserved',
      bg: 'резервирана',
      ru: 'зарезервированный'
    }
	},{
		id: 81,
		number: '1 E',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		netArea: 8.66,
		grossArea: 8.66,
		price: 3325.44,
		taxPrice: 4286.7,
    status: {
      en: 'reserved',
      bg: 'резервирана',
      ru: 'зарезервированный'
    }
	},{
		id: 82,
		number: '2 E',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		netArea: 4.68,
		grossArea: 4.68,
		price: 1797.12,
		taxPrice: 2316.6,
		status: {
			en: 'available',
			bg: 'свободна',
			ru: 'свободный'
		}
	},{
		id: 83,
		number: '3 E',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		netArea: 4.94,
		grossArea: 4.94,
		price: 1896.96,
		taxPrice: 2445.3,
		status: {
			en: 'available',
			bg: 'свободна',
			ru: 'свободный'
		}
	},{
		id: 84,
		number: '4 E',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		netArea: 5.21,
		grossArea: 5.21,
		price: 2000.64,
		taxPrice: 2578.95,
		status: {
			en: 'available',
			bg: 'свободна',
			ru: 'свободный'
		}
	},{
		id: 85,
		number: '5 E',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		netArea: 4.85,
		grossArea: 4.85,
		price: 1862.4,
		taxPrice: 2400.75,
		status: {
			en: 'available',
			bg: 'свободна',
			ru: 'свободный'
		}
	},{
		id: 86,
		number: '6 E',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		netArea: 4,
		grossArea: 4,
		price: 1536,
		taxPrice: 1980,
		status: {
			en: 'available',
			bg: 'свободна',
			ru: 'свободный'
		}
	},{
		id: 87,
		number: '7 E',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		netArea: 4.45,
		grossArea: 4.45,
		price: 1708.8,
		taxPrice: 2202.75,
		status: {
			en: 'available',
			bg: 'свободна',
			ru: 'свободный'
		}
	},{
		id: 88,
		number: '8 E',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		netArea: 6,
		grossArea: 6,
		price: 2304,
		taxPrice: 2970,
    status: {
      en: 'reserved',
      bg: 'резервирана',
      ru: 'зарезервированный'
    }
	},{
		id: 89,
		number: '9 E',
		type: {
			en: 'cellar',
			bg: 'изба',
			ru: 'подвал'
		},
		netArea: 3.27,
		grossArea: 3.27,
		price: 1255.68,
		taxPrice: 1618.65,
		status: {
			en: 'available',
			bg: 'свободна',
			ru: 'свободный'
		}
	},
]



// WEBPACK FOOTER //
// ./src/utils/redux/config/parking.js